// types
import { CostCenterDetail } from '../types';
import { OptionWithValidFrom } from './useCreateCostCenterDetailOptions.types';

// utils
import dayjs from 'dayjs';
import { formatCostCenterDetailLabel } from '../components/form/utils/utils';

const useCreateCostCenterDetailOptions = (
  costCenterDetails?: CostCenterDetail[]
) => {
  if (!costCenterDetails || costCenterDetails.length === 0) {
    return [];
  }

  return costCenterDetails.map((item) => {
    return {
      value: item.brDynId,
      label: formatCostCenterDetailLabel(item),
      code: item.code,
      validFrom: dayjs(item.valid.from).isValid()
        ? dayjs(item.valid.from).valueOf()
        : -1
    };
  }) as OptionWithValidFrom[];
};

export default useCreateCostCenterDetailOptions;
